import React, { useCallback } from 'react';

import { LegacyBox } from '@gogame/components';
import { useScreenDispatch, useScreenState } from '@gogame/screens';

import { SET_CHARTS_WIDTHS } from 'scenes/Trackers/Tracker/reducers';

import { ChartDataProvider } from './Chart';
import ChartResize from './Resize';
import TrackerChart from './TrackerChart';

const TrackerCharts = ({
  withPaper = true,
  tooltipPosStrategy,
  presetName,
}) => {
  const dispatch = useScreenDispatch();
  const screenState = useScreenState();

  const handleResize = useCallback(
    (widths) => {
      dispatch({
        type: SET_CHARTS_WIDTHS,
        payload: widths,
      });
    },
    [dispatch]
  );

  const defaultWidth = Number((100 / screenState.charts.length).toFixed(2));

  return (
    <div>
      <LegacyBox
        wrap={'wrap'}
        style={{
          margin: withPaper ? '-8px' : 0,
        }}
      >
        <ChartResize onResize={handleResize} minWidth={620}>
          {screenState.charts.map(({ width, metrics }, index) => {
            //todo remove second chart
            const isLast = index === screenState.charts.length - 1;
            return (
              <ChartResize.Cell
                isLast={isLast}
                width={width || defaultWidth}
                key={`${index}_${metrics && metrics.toString()}`}
                style={{
                  padding: withPaper ? '8px' : '0',
                }}
              >
                <ChartDataProvider index={index}>
                  <TrackerChart
                    withPaper={withPaper}
                    tooltipPosStrategy={tooltipPosStrategy}
                    presetName={presetName}
                  />
                </ChartDataProvider>
              </ChartResize.Cell>
            );
          })}
        </ChartResize>
      </LegacyBox>
    </div>
  );
};

export default TrackerCharts;
